<template>
  <div>
    <b-modal :title="'مدیریت صدور مدرک'" id="certificateModal" v-model="showModal" no-close-on-esc header-close-variant="dark" hide-footer centered>
      <div class="__context">
        <div>
          <div class="d-flex gap-2">
            <p v-text="'تعداد اعضا :'" />
            <span class="text-primary">{{ selectedCertificate.NumberOfPeople || '--' }}</span>
            <span v-text="'نفر'" />
          </div>

          <div class="d-flex gap-2">
            <p v-text="'تاریخ : '" />
            <span>{{ convertDate(selectedCertificate.StartDate) }}</span>
          </div>

          <div>
            <span v-text="selectedCertificate.Title" />
          </div>
        </div>

        <div>
          <div class="d-flex gap-2">
            <p v-text="'شماره مجوز : '" />
            <span>{{ selectedCertificate.Code }}</span>
          </div>

          <div class="d-flex gap-2">
            <p v-text="'دانشکده :'" />
            <span>{{ selectedCertificate.FacultyTitle }}</span>
          </div>

          <div>
            <span v-text="selectedCertificate.EnglishTitle" />
          </div>
        </div>
      </div>

      <hr />

      <div class="mt-4 d-flex">
        <BaseText
          v-if="row"
          v-model="number"
          @input="setStepNumber"
          title="شماره گواهی از  "
          placeholder="شماره"
          style="width: 284px"
          required
          :errortext="errorText"
          :showError="submit && !number"
        />

        <BaseText
          v-else
          v-model="number"
          @input="setNumber"
          title="شماره گواهی از  "
          placeholder="شماره"
          style="width: 284px"
          required
          :errortext="errorText"
          :showError="submit && !number"
        />

        <div class="__certificate_number gap-2">
          <p v-text="' تا  '" />
          <p v-text="numberOfCertificate[1]" />
        </div>
      </div>

      <div class="w-100 mt-2">
        <ComboBox
          :searchedData="formatType"
          title="قالب"
          placeholder="قالب"
          :selectedValue="selectedFormat"
          @select="fillSelectedModel"
          :inputStyle="comboStyle"
          required
          :errortext="errorText"
          :showError="submit && !selectedFormat.length"
        />
      </div>

      <div class="d-flex justify-content-end align-items-center mt-3 gap-2">
        <b-button variant="secondary" @click="$bvModal.hide('certificateModal')">انصراف</b-button>
        <b-button @click="printCertificate" :disabled="createCertificateRequest" :loading="loading" :class="['upload-btn', { 'download-btn': createCertificateRequest }]">
          ساخت مدارک
        </b-button>

        <b-button
          @click="downloadCertificate"
          :loading="downloadLoading"
          :disabled="downloadDisabled && !createCertificateRequest"
          :class="['upload-btn', { 'download-btn': downloadDisabled && !createCertificateRequest }]"
        >
          دانلود مدارک
        </b-button>
      </div>
    </b-modal>

    <Toast :showToast="showToast" :error="true" :title="message" />
  </div>
</template>

<script>
import moment from 'jalali-moment'
import Toast from '../../common/Toast.vue'
import BaseText from '../../common/form/formModules/BaseText.vue'
import ComboBox from '../../common/form/formModules/ComboBox.vue'
import moocIssuanceCertificate from '../../../services/mooc/issuanceOfACertificate'

export default {
  name: 'PrintCertificatesModal',
  components: { BaseText, ComboBox, Toast },
  props: {
    certificateMode: { type: Object, default: () => {} },
  },

  data: () => {
    return {
      message: '',
      number: null,
      submit: false,
      loading: false,
      row: undefined,
      showToast: false,
      showModal: false,
      selectedFormat: '',
      numberOfMember: null,
      showModalOnce: false,
      downloadLoading: false,
      downloadDisabled: true,
      selectedCertificate: {},
      numberOfCertificate: [],
      downloadedCertificate: [],
      printCertificateRequest: '',
      comboStyle: 'color: #495057',
      createCertificateRequest: false,
      errorText: 'وارد کردن این فیلد الزامی است',
      formatType: [
        { key: 0, value: 'عمودی' },
        { key: 1, value: 'افقی' },
      ],
    }
  },
  methods: {
    setNumber() {
      this.numberOfCertificate[0] = Number(this.number)
      this.numberOfCertificate[1] = Number(this.number) + Number(this.selectedCertificate.NumberOfPeople)
    },
    setStepNumber() {
      this.numberOfCertificate[0] = Number(this.number)
      if (this.number) this.numberOfCertificate[1] = Number(this.number) + 1
    },
    convertDate(date) {
      if (!date) return '--'
      let finalTime = moment(date).locale('fa').format('YYYY/M/D')
      return finalTime
    },
    fillSelectedModel(e) {
      this.selectedFormat = this.formatType.find((t) => t?.value === e)?.value
    },
    downloadCertificate() {
      this.$router.push({
        name: 'mooc-print-licenses',
        params: { type: this.selectedFormat === 'عمودی' ? 'vertical' : 'horizontal', courseId: this.selectedCertificate.Id },
        query: { code: this.selectedCertificate.Code },
      })
    },
    async printCertificate() {
      this.createCertificateRequest = true
      const state = {
        number: Number(this.number),
        selectedFormat: this.selectedFormat,
        createCertificateRequest: this.createCertificateRequest,
        NumberOfPeople: this.selectedCertificate.NumberOfPeople,
        courseId: this.$route.params.courseId,
      }

      localStorage.setItem('printInformation', JSON.stringify(state))
      this.submit = true
      if (!this.number || !this.selectedFormat?.length) {
        return false
      }
      this.downloadDisabled = true
      try {
        this.loading = true
        const req = await moocIssuanceCertificate.applyCertificate({
          number: this.numberOfCertificate[1],
          courseId: this.$route.params.courseId,
        })

        this.loading = false

        this.printCertificateRequest = req.data.data.output
        this.downloadDisabled = true
        this.downloadLoading = true
        setTimeout(() => {
          this.downloadDisabled = false
          this.downloadLoading = false
        }, 20000)
      } catch (error) {
        this.loading = false
        this.createCertificateRequest = false
        this.showToast = true
        this.message = error.response.data.message
      }
    },
  },
  mounted() {
    const newState = JSON.parse(localStorage.getItem('printInformation'))
    if (newState && newState.courseId === this.$route.params.courseId) {
      this.number = newState.number
      this.selectedFormat = newState.selectedFormat
      this.createCertificateRequest = newState.createCertificateRequest
      this.selectedCertificate.NumberOfPeople = newState.NumberOfPeople
      this.setNumber()
    }

    this.selectedCertificate = JSON.parse(localStorage.getItem('certificateInformation'))
    this.row = undefined
  },
  watch: {
    certificateMode(value) {
      this.row = value
      if (this.row) this.setStepNumber()
    },
    showModal(val) {
      if (!val) {
        this.number = null
        this.numberOfCertificate = []
        this.row = undefined
        this.submit = false
      }
    },
    deep: true,
  },
}
</script>

<style lang="scss">
.__context {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  // width: 21rem;
}

.__context p {
  color: #999696;
}

.__input {
  min-width: 10px !important;
}

.__certificate_number {
  margin: 0.5rem 1rem;
  display: flex;
}

.upload-btn {
  margin-right: 10px !important;
  background: #556ee6 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px 28px !important;
}

.download-btn {
  margin-right: 10px !important;
  background: #585b69 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px 28px !important;
}

._download_btn {
  margin-right: 10px !important;
  background: #556ee6 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px !important;
}
</style>
